import '../internals/custom-jquery';
import '../internals/global';


/**
 * Function utilisée sur le formulaire "Postuler"
 */

 (function(w) {
    w.Kinougarde = Object.assign({},w.Kinougarde, { Postuler : {}});
    /**
     * Initialisation du formulaire
     */
    w.Kinougarde.Postuler.initFormulairePostuler = function() {        
              
        var idCandidature= null;

        // Valeur par défaut du formulaire        
        var dataPostuler = Kinougarde.GetStorage("form-postuler");
        Kinougarde.formulaireAcf.InitFormulaire({ defaultValue : dataPostuler});
               
        // Après le le passage à l'étape "Etat civil"
        jQuery("#step_status").on("form-step-next-changed",function(event, options) {
            // Supprime le message nouvelle agence
            $(".nouvelle-agence").remove();
        });

        // Capte le click sur "Postuler" de l'étape Véhicule
        // Avant le changement d'étape
        jQuery("#step_vehicule").on("form-step-next-change",function(event, options) {
            // Ajoute l'id de l'offre contenu dans l'url aux paramètres de la requete ajax
            //Ainsi que l'url de la page pour la conversion via l'Api facebookConversion
            options.data = {"url" : document.location.href};
            if (Kinougarde.GetParameterByName("job_id")!=null){
                options.data =  Object.assign(options.data, {"offer_id": Kinougarde.GetParameterByName("job_id")});
            }
            return options;
        });

        // Capte les évènements ajax-action-success sur l'étape de confirmation de la candidature
        // Après le changement d'étape
        jQuery("#step_vehicule").on("form-step-next-changed", function(e,reponse,data) {
            // Affiche le bon message selon que l'utilisateur est ciblé ou non
            if (reponse.data.data.Prioritaire) {
                // Candidat prioritaire
                Kinougarde.Postuler.CandidaturePrioritaire =true;                                
                Kinougarde.TagManagerTunnel("Postuler/step-5",{ Prioritaire : true , ValeurCandidature : reponse.data.data.IaEstimationNombreHeuresCollectees * reponse.data.data.IaEstimationTauxConversion })
            } else 
            {
                // Candidat non prioritaire
                Kinougarde.Postuler.CandidaturePrioritaire = false;                
                Kinougarde.TagManagerTunnel("Postuler/step-5",{ Prioritaire : false , ValeurCandidature : reponse.data.data.IaEstimationNombreHeuresCollectees * reponse.data.data.IaEstimationTauxConversion })                
            } 
            //Mémorise l'id de la candidature pour réutilisation 
            idCandidature = reponse.data.data.Id;          
            data.id = idCandidature;
            // Mise à jour des infos de l'agence
            w.Kinougarde.UpdateAgence(reponse.data.data.Agence);
                       

            // Mémorise les données du formulaire pour une prochaine utilisation
            // se base sur le consentement de l'utilisateur
            Kinougarde.SetStorage("form-postuler",data);

            // Ajout de la reference de l'offre dans la liste des offres déjà postulées
            try {
                if (data.offer_id!==null && typeof(data.offer_id)!=='undefined') {
                    var offresDejaPostulees = Kinougarde.GetStorage("offres-emploi-postulees");
                    if (typeof(offresDejaPostulees)==='undefined' || offresDejaPostulees===null) {
                        offresDejaPostulees= [];
                    }
                    // Ajout uniquement si non présent dans offresDejaPostulees                                       
                    offresDejaPostulees.push(data.offer_id);        
                    Kinougarde.SetStorage("offres-emploi-postulees",offresDejaPostulees.filter((item, pos) => offresDejaPostulees.indexOf(item) === pos));
                }
            } catch (e) {}   
                        
            // Redirection vers la page des disponibilité
            document.location.href = "/mes-disponibilites/" + reponse.data.data.SecurityKey +"/"; 

        });
                        

        // Capte les évènements agence-loaded
        if (Kinougarde.agence!=='undefined' && Kinougarde.agence!==null) {
            Kinougarde.Postuler.AfficheMessageNouvelleAgence(Kinougarde.agence);
        }else {
            jQuery(document).on('agence-loaded', function(ev,data) {
                Kinougarde.Postuler.AfficheMessageNouvelleAgence(data);
            });
        }

                                        
    };  
    
    // Affiche le message pour les nouvelles agences
    w.Kinougarde.Postuler.AfficheMessageNouvelleAgence = function(agence) {
        try {
            if (typeof(agence)!=='undefined' &&  agence.NouvelleAgence===true && Kinougarde.formulaireAcf.CurrentIndex()==0)  {
                // Kinougarde.msgNouvelleAgence  contient le message à afficher
                var msg = Kinougarde.msgNouvelleAgence.replace("[agence]",'<b>' + agence.Libelle + '</b>');
                jQuery("#section-postuler").prepend("<div class=\"nouvelle-agence\">"+ msg+"</div>");
            }
            }
            catch(e) {
                console.info("erreur set nouvelle agence");
        }
    }
    
})(window);

jQuery(function() {
    try {
    if (jQuery("#section-postuler").length>0) {               
        Kinougarde.Postuler.initFormulairePostuler();        
    };   
    }     
    catch (ex) {
        console.error(ex);
    }
});